import React from 'react';

const GameBoardIcon = () => (
  <svg className="w-24 h-24 text-jskool-gold" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 80C20 80 35 80 40 70C45 60 35 50 30 40C25 30 40 20 50 20" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="10 5"/>
    <path d="M60 80C60 80 65 65 70 60C75 55 80 65 80 50C80 35 70 25 60 20" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="15" y="15" width="10" height="10" rx="2" fill="currentColor"/>
    <rect x="75" y="75" width="10" height="10" rx="2" fill="currentColor"/>
    <rect x="55" y="15" width="10" height="10" rx="2" fill="currentColor"/>
  </svg>
);

const MokshaPatamPage: React.FC = () => {
  return (
    <section 
        className="flex-grow flex items-center bg-jskool-cream" 
        style={{
            backgroundImage: `radial-gradient(circle at top right, #4285f41a, transparent 40%),
                              radial-gradient(circle at bottom left, #f4b4001a, transparent 40%)`
        }}
    >
      <div className="container mx-auto px-6 py-20 text-center flex flex-col items-center">
        <GameBoardIcon />
        <h1 className="text-4xl md:text-6xl font-heading font-black mt-6 text-jskool-dark">Moksha Patham</h1>
        <p className="font-heading text-2xl md:text-3xl font-bold mt-2 bg-clip-text text-transparent bg-gradient-to-r from-jskool-blue to-jskool-green">Coming Soon!</p>
        
        <div className="max-w-3xl mx-auto mt-8 text-lg text-jskool-dark/80 space-y-4">
            <p>Get ready to embark on a spiritual journey with <span className="font-bold">Moksha Patham</span>, the ancient Jain game of liberation, reimagined for the digital age.</p>
            <p>Navigate a board of virtues and vices, where ladders of good deeds (<span className="text-jskool-blue font-semibold">punya</span>) elevate you closer to enlightenment, and snakes of misdeeds (<span className="text-jskool-red font-semibold">paap</span>) pull you back into the cycle of rebirth. It's more than just a game—it's a playful path to understanding karma and righteousness.</p>
        </div>

        <div className="mt-12">
            <div className="bg-white rounded-xl shadow-lg p-6 inline-block">
                <p className="font-heading font-bold text-xl text-jskool-dark">Stay tuned for the official launch!</p>
                <p className="text-jskool-dark/70 mt-1">Prepare to roll the dice and ascend to <span className="font-semibold">Moksha</span>!</p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default MokshaPatamPage;
